import 'react';
import { styled } from '@mui/system';
import i18n from '../../utils/i18n';
import SignInBtn from './SignInBtn';

const SignInScreen = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  backgroundSize: 'cover',
  fontFamily: 'Open Sans',
  minHeight: 660,
});
const MainArea = styled('div')({
  width: '100%',
  color: '#0b3669',
  height: 'calc( 100vh - 110px)',
});
const SubHeading = styled('div')({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '17px',
  lineHeight: '24px',
  color: '#757575',
  marginTop: '8px',
  width: 436
});
const TextArea = styled('div')({
  width: '50%',
  boxSizing: 'border-box',
  padding: '0 5%',
  textAlign: 'left',
  marginTop: 130,
  flexDirection: 'column'
});
const HeaderText = styled('h1')({
  userSelect: 'none',
  margin: 0,
  fontFamily: 'Platform Web',
  fontSize: 43,
  fontWeight: 500,
  lineHeight: '53px',
  color: '#1a1a1a',
  whiteSpace: 'pre-line',
  width: 436,
});
const SignInArea = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: 24,
});
const SignInBtnContaner = styled('div')({
  width: '310px',
  marginBottom: 16,
});

export default function DefaultSignIn(props: {
  signInWithGoogle: () => void;
  signInWithApple: () => void;
  signInWithAnonymous: () => void;
  goSignInWithEmailPage: () => void;
  backgroundImage: string;
  showAnonymous?: boolean;
}) {
  const { signInWithGoogle, signInWithApple, signInWithAnonymous, goSignInWithEmailPage, backgroundImage, showAnonymous } = props;

  return <SignInScreen  style={{ backgroundImage: `url(${backgroundImage})` }}>
    <MainArea>
      <TextArea>
        <HeaderText>{i18n.t("ldpage_heading_title")}</HeaderText>
        <SubHeading dangerouslySetInnerHTML={{ __html: i18n.t('sign_in_same_account') }} />
        <SignInArea id='signInArea'>
          <SignInBtnContaner onClick={(event) => signInWithGoogle()}>
            <SignInBtn type="google" />
          </SignInBtnContaner>
          <SignInBtnContaner onClick={(event) => goSignInWithEmailPage()}>
              <SignInBtn type="email" />
          </SignInBtnContaner>
          <SignInBtnContaner onClick={(event) => signInWithApple()}>
              <SignInBtn type="apple" />
          </SignInBtnContaner>
          {
            showAnonymous && <SignInBtnContaner onClick={(event) => signInWithAnonymous()}>
                <SignInBtn type="anonymous" />
            </SignInBtnContaner>
          }
        </SignInArea>
      </TextArea>
    </MainArea>
  </SignInScreen>
}
